import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetupApprovalEditPage } from './setup-approval-edit.page';

const routes: Routes = [
  {
    path: '',
    component: SetupApprovalEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SetupApprovalEditPageRoutingModule {}
